<template>
  <Video 
    class="videoPlayer"
    :src="videoUrl" 
    controls 
    autoplay="autoplay"  
    :controlsList="'nodownload'" 
    @contextmenu.prevent 
    ref="videoPlayer">
  </Video>
</template>

<script>
export default {
  name: "VideoPlayerDetail",
  props: {
    playerId: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      videoUrl: "",
      playerTitle: ""
    };
  },
  mounted () {
    // console.log('VideoPlayerDetail mounted');
  },
  methods: {
    // 接收视频URL和标题的方法
    openVideo(url, title) {
      this.videoUrl = url; // 设置视频URL
      this.playerTitle = title; // 保存标题
      
      // 可选：如果Video组件有播放方法，可以在这里调用
      // this.$refs.videoPlayer.play();
    }
  }
};
</script>

<style scoped>
  .videoPlayer{
    width: 100%;
    border-radius:10px;
    border:1px solid #ddd;
  }
</style>